export default __webpack_public_path__ + "static/media/bedroom.a80af3c7.webp";